<template>
  <div class="re-authenticate">
    <h6 class="sub-section-title">
      Re-Authenticate
    </h6>

    <div class="info-content">
      <div class="info-comment">
        Please enter your password to continue with this action.
      </div>

      <div class="form-group mt-4 text-center">
        <input 
          v-model="password" 
          type="password" 
          class="form-control"
          placeholder="Enter your password"
          :disabled="status.isLoading"
        >
        <button 
          class="btn btn-primary mt-3" 
          :disabled="status.isLoading || !password"
          @click="handleReAuthenticate"
        >
          {{ status.isLoading ? 'Verifying...' : 'Continue' }}
        </button>
      </div>

      <message-html :result-html="status.resultHtml" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useUserType } from '@/use/userType';

import { sendPost } from '@/Utils/api';
import util from '@/Utils/util';

const router = useRouter();
const { userType } = useUserType();
const password = ref('');

const status = reactive({
  isLoading: false,
  resultHtml: '',
});

const handleReAuthenticate = async () => {
  if (!password.value || status.isLoading) return;

  status.isLoading = true;
  try {
    await sendPost('/re-authenticate', { password: password.value });
    const returnUrl = router.currentRoute.value.query.returnUrl as string;
    router.push(returnUrl || `/${userType.value}/2fa`);
  } catch (error: any) {
    status.resultHtml = util.getErrorResponse(error);
  } finally {
    status.isLoading = false;
  }
};

const handleCancel = () => {
  router.push(`/${userType.value}/2fa`);
};
</script>

<style lang="scss">
.re-authenticate {
  .info-content {
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

    .info-comment {
      color: #666;
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
    }

    .form-group {
      max-width: 300px;
      margin: 0 auto;
      
      .form-control {
        text-align: center;
      }
    }
  }
}
</style> 